var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1073,
    height: 1080,
    viewBox: "0 0 1073 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1073,
    height: 1080,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 1 584 26)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "matrix(-1 0 0 1 549.5 54.5)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(-1 0 0 1 508.5 55)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(-1 0 0 1 468.5 55)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(-1 0 0 1 549 101)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(-1 0 0 1 509 101)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(-1 0 0 1 469 101)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(-1 0 0 1 549 147)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(-1 0 0 1 509 147)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(-1 0 0 1 469 147)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 1 584 206)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(-1 0 0 1 534 256)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 1 404 206)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 206C224 302.65 302.35 386 399 386C495.65 386 574 307.65 574 211C574 114.35 495.65 36 399 36C302.35 36 224 109.35 224 206ZM488.664 211C488.664 260.52 448.52 300.664 399 300.664C349.48 300.664 309.336 260.52 309.336 211C309.336 161.48 349.48 121.336 399 121.336C448.52 121.336 488.664 161.48 488.664 211Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 1 224 26)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 4,
    transform: "matrix(-1 0 0 1 174 76)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 1 404 26)",
    fill: "#B0C9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.886 66.8858L404 26H224V206L362.886 66.8858Z",
    fill: "#0B68FE"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(0 -1 1 0 44 386)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8858 344.886L44 386L44 206H224L84.8858 344.886Z",
    fill: "#0B68FE"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 -1 1124 386)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944 381C944 284.35 1022.35 206 1119 206C1215.65 206 1294 284.35 1294 381C1294 477.65 1215.65 556 1119 556C1022.35 556 944 477.65 944 381ZM1208.66 381C1208.66 331.48 1168.52 291.336 1119 291.336C1069.48 291.336 1029.34 331.48 1029.34 381C1029.34 430.52 1069.48 470.664 1119 470.664C1168.52 470.664 1208.66 430.52 1208.66 381Z",
    fill: "#B0C9FB"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 -1 1124 206)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1074,
    y: 156,
    width: 80,
    height: 80,
    rx: 4,
    transform: "rotate(180 1074 156)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 -1 944 206)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594 201C594 104.35 672.35 26 769 26C865.65 26 944 104.35 944 201C944 297.65 865.65 376 769 376C672.35 376 594 297.65 594 201ZM858.664 201C858.664 151.48 818.52 111.336 769 111.336C719.48 111.336 679.336 151.48 679.336 201C679.336 250.52 719.48 290.664 769 290.664C818.52 290.664 858.664 250.52 858.664 201Z",
    fill: "#B0C9FB"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 -1 764 386)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.919 232.36C773.066 267.508 773.066 324.492 737.919 359.64C702.772 394.787 645.787 394.787 610.64 359.64C575.492 324.492 575.492 267.508 610.64 232.36C645.787 197.213 702.772 197.213 737.919 232.36ZM641.672 328.607C659.681 346.615 688.878 346.615 706.886 328.607C724.894 310.599 724.894 281.401 706.886 263.393C688.878 245.385 659.681 245.385 641.672 263.393C623.664 281.401 623.664 310.599 641.672 328.607Z",
    fill: "#B0C9FB"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(1 0 0 -1 764 386)",
    fill: "#B0C9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.114 344.886L764 386H944V206L805.114 344.886Z",
    fill: "#0B68FE"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(1 0 0 -1 584 206)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.114 164.886L584 206H764V26L625.114 164.886Z",
    fill: "#0B68FE"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "translate(-136 -154)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "translate(44 -154)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 -144C389 -47.3502 310.65 31 214 31C117.35 31 39 -47.3502 39 -144C39 -240.65 117.35 -319 214 -319C310.65 -319 389 -240.65 389 -144ZM124.336 -144C124.336 -94.4799 164.48 -54.3359 214 -54.3359C263.52 -54.3359 303.664 -94.4799 303.664 -144C303.664 -193.52 263.52 -233.664 214 -233.664C164.48 -233.664 124.336 -193.52 124.336 -144Z",
    fill: "#B0C9FB"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 1 404 -154)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.886 -113.114L404 -154H224V26L362.886 -113.114Z",
    fill: "#0B68FE"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "translate(44 386)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 430,
    r: 15.5,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 430,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 430,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 476,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 476,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 476,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 522,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 522,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 522,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 1 404 386)",
    fill: "#B0C9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.886 426.886L404 386H224V566L362.886 426.886Z",
    fill: "#0B68FE"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "translate(404 386)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454,
    y: 436,
    width: 80,
    height: 80,
    rx: 4,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "translate(44 566)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 616,
    width: 80,
    height: 80,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 -1 404 746)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.114 704.886L224 746H404V566L265.114 704.886Z",
    fill: "#0B68FE"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 1 584 566)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.919 592.36C593.066 627.508 593.066 684.492 557.919 719.64C522.772 754.787 465.787 754.787 430.64 719.64C395.492 684.492 395.492 627.508 430.64 592.36C465.787 557.213 522.772 557.213 557.919 592.36ZM461.672 688.607C479.681 706.615 508.878 706.615 526.886 688.607C544.894 670.599 544.894 641.401 526.886 623.393C508.878 605.385 479.681 605.385 461.672 623.393C443.664 641.401 443.664 670.599 461.672 688.607Z",
    fill: "#B0C9FB"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "translate(584 386)",
    fill: "#B0C9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.114 524.886L584 566H764V386L625.114 524.886Z",
    fill: "#0B68FE"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "translate(764 386)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814,
    cy: 430,
    r: 15.5,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 854.5,
    cy: 430,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 894.5,
    cy: 430,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814,
    cy: 476,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 854,
    cy: 476,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 894,
    cy: 476,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814,
    cy: 522,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 854,
    cy: 522,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 894,
    cy: 522,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "translate(944 386)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 994,
    y: 436,
    width: 80,
    height: 80,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "translate(584 566)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634,
    y: 616,
    width: 80,
    height: 80,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "translate(764 566)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114 571C1114 667.65 1035.65 746 939 746C842.35 746 764 667.65 764 571C764 474.35 842.35 396 939 396C1035.65 396 1114 474.35 1114 571ZM849.336 571C849.336 620.52 889.48 660.664 939 660.664C988.52 660.664 1028.66 620.52 1028.66 571C1028.66 521.48 988.52 481.336 939 481.336C889.48 481.336 849.336 521.48 849.336 571Z",
    fill: "#B0C9FB"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 1 1124 566)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.89 607.114L1124 566H944V746L1082.89 607.114Z",
    fill: "#0B68FE"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 -1 44 206)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -6,
    cy: 162,
    r: 15.5,
    transform: "rotate(180 -6 162)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -6,
    cy: 116,
    r: 15,
    transform: "rotate(180 -6 116)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -6,
    cy: 70,
    r: 15,
    transform: "rotate(180 -6 70)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 -1 44 386)",
    fill: "#B0C9FB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(1 0 0 -1 -136 566)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-94.8858 525.114L-136 566H44V386L-94.8858 525.114Z",
    fill: "#0B68FE"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(1 0 0 -1 -136 746)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(1 0 0 -1 -136 1106)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(1 0 0 -1 -20.5 1077)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(1 0 0 -1 -21 1031)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(1 0 0 -1 -21 985)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "translate(44 926)",
    fill: "#B0C9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1142 967.114L44 926H224V1106L85.1142 967.114Z",
    fill: "#0B68FE"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(1 0 0 -1 224 1106)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 4,
    transform: "matrix(1 0 0 -1 274 1056)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 -1 404 926)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 876,
    width: 80,
    height: 80,
    rx: 4,
    transform: "rotate(180 354 876)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 -1 224 926)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-126 750.917C-126 654.267 -47.6498 575.917 49 575.917C145.65 575.917 224 654.267 224 750.917C224 847.567 145.65 925.917 49 925.917C45.6438 925.917 42.3096 926.104 39 925.917C-52.9969 920.735 -126 844.211 -126 750.917ZM138.664 750.917C138.664 701.397 98.5201 661.253 49 661.253C-0.520111 661.253 -40.6641 701.397 -40.6641 750.917C-40.6641 800.437 -0.520111 840.581 49 840.581C98.5201 840.581 138.664 800.437 138.664 750.917Z",
    fill: "#B0C9FB"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(1 0 0 -1 -136 926)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-95.1129 884.886L-136 926H44V746L-95.1129 884.886Z",
    fill: "#0B68FE"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 1 1124 746)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.92 772.36C1133.07 807.508 1133.07 864.492 1097.92 899.64C1062.77 934.787 1005.79 934.787 970.64 899.64C935.492 864.492 935.492 807.508 970.64 772.36C1005.79 737.213 1062.77 737.213 1097.92 772.36ZM1001.67 868.607C1019.68 886.615 1048.88 886.615 1066.89 868.607C1084.89 850.599 1084.89 821.401 1066.89 803.393C1048.88 785.385 1019.68 785.385 1001.67 803.393C983.664 821.401 983.664 850.599 1001.67 868.607Z",
    fill: "#B0C9FB"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 1 1124 926)",
    fill: "#DAE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 4,
    transform: "matrix(-1 0 0 1 1074 976)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 1 944 746)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 4,
    transform: "matrix(-1 0 0 1 894 796)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 1 764 746)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "matrix(-1 0 0 1 729.5 774.5)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(-1 0 0 1 688.5 775)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(-1 0 0 1 648.5 775)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(-1 0 0 1 729 821)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(-1 0 0 1 689 821)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(-1 0 0 1 649 821)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(-1 0 0 1 729 867)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(-1 0 0 1 689 867)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(-1 0 0 1 649 867)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "translate(404 746)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.114 787.114L404 746H584V926L445.114 787.114Z",
    fill: "#0B68FE"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip23_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 1 944 926)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594 931C594 1027.65 672.35 1106 769 1106C865.65 1106 944 1027.65 944 931C944 834.35 865.65 756 769 756C672.35 756 594 834.35 594 931ZM858.664 931C858.664 980.52 818.52 1020.66 769 1020.66C719.48 1020.66 679.336 980.52 679.336 931C679.336 881.48 719.48 841.336 769 841.336C818.52 841.336 858.664 881.48 858.664 931Z",
    fill: "#B0C9FB"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 1 764 926)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 4,
    transform: "matrix(-1 0 0 1 714 976)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip24_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(1 0 0 -1 584 926)",
    fill: "#B0C9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.887 884.886L584 926H768.5L764 746L624.887 884.886Z",
    fill: "#0B68FE"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "translate(404 926)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 970,
    r: 15.5,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 494.5,
    cy: 970,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 534.5,
    cy: 970,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 1016,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 1016,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 534,
    cy: 1016,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 1062,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 1062,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 534,
    cy: 1062,
    r: 15,
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "translate(404 -154)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25_1224_11286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "translate(584 -154)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929 -144C929 -47.3502 850.65 31 754 31C657.35 31 579 -47.3502 579 -144C579 -240.65 657.35 -319 754 -319C850.65 -319 929 -240.65 929 -144ZM664.336 -144C664.336 -94.4799 704.48 -54.3359 754 -54.3359C803.52 -54.3359 843.664 -94.4799 843.664 -144C843.664 -193.52 803.52 -233.664 754 -233.664C704.48 -233.664 664.336 -193.52 664.336 -144Z",
    fill: "#B0C9FB"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 1 944 -154)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.886 -113.114L944 -154H764V25L902.886 -113.114Z",
    fill: "#0B68FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1073,
    height: 1080,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(-1 0 0 1 404 206)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(-1 0 0 1 404 26)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(0 -1 1 0 44 386)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(-1 0 0 -1 1124 386)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(-1 0 0 -1 944 206)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(-1 0 0 -1 764 386)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(1 0 0 -1 764 386)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(1 0 0 -1 584 206)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "translate(44 -154)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(-1 0 0 1 404 -154)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(-1 0 0 1 404 386)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(-1 0 0 -1 404 746)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(-1 0 0 1 584 566)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "translate(584 386)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "translate(764 566)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(-1 0 0 1 1124 566)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(1 0 0 -1 -136 566)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "translate(44 926)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(-1 0 0 -1 224 926)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(1 0 0 -1 -136 926)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(-1 0 0 1 1124 746)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "translate(404 746)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(-1 0 0 1 944 926)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(1 0 0 -1 584 926)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25_1224_11286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "translate(584 -154)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBackground);
export default __webpack_public_path__ + "static/media/auth-background.0c533b67ced6ef96e1dd00a5b27028b7.svg";
export { ForwardRef as ReactComponent };